export default __webpack_public_path__ + "static/media/jennifer-dezeeuw.5c2ccbc3.jpg";